<template>
    <div>
        <el-table :data="tableData.cols" max-height="500px" v-if="addModel==1" border>
            <el-table-column prop="name" label="颜色\尺码" min-width="100px">
            </el-table-column>
            <el-table-column v-for="(size,index) in tableData.sizeList" :key="index"
                 :label="size" width="120px"
            >
                <template slot-scope="scope">
                    <div v-if="scope.row[size].id==-1"></div>
                    <div v-else>
                        <el-input
                            :min="0"
                            v-show="$global.buyType!=2"
                            v-model="scope.row[size].count"
                            style="width: 100px"
                            @input="checkSpNumber($event,scope.row[size],'count')"
                        >
                            <span slot="suffix" style="line-height: 40px;">{{$global.pack}}</span>
                        </el-input>
                        <div style="height:5px" v-if="$global.buyType==0"></div>
                        <el-input
                            :min="0"
                            v-show="$global.buyType!=1"
                            v-model="scope.row[size].num"
                            style="width: 100px"
                            @input="checkSpNumber($event,scope.row[size],'num')"
                        >
                         <span slot="suffix" style="line-height: 40px;">{{$global.unit}}</span>
                         </el-input>
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="20px">
            </el-table-column>
        </el-table>
        <el-table :data="tableData.specs" max-height="500px" v-else-if="addModel==2" border>
            <el-table-column label="规格" min-width="100px">
                <template slot-scope="scope">
                    <span>{{scope.row.color+"/"+scope.row.size}}</span>
                </template>
            </el-table-column>
            <el-table-column label="数量" min-width="180px" v-if="$global.buyType!=2">
                <template slot-scope="scope">
                    <el-input
                        :min="0"
                        v-model="scope.row.count"
                        style="width: 160px"
                        @input="checkSpNumber($event,scope.row,'count')"
                    >
                        <span slot="suffix" style="line-height: 40px;">{{$global.pack}}</span>
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column label="零头" min-width="180px" v-if="$global.buyType!=1">
                <template slot-scope="scope">
                    <el-input
                        :min="0"
                        v-model="scope.row.num"
                        style="width: 160px"
                        @input="checkSpNumber($event,scope.row,'num')"
                    >
                        <span slot="suffix" style="line-height: 40px;">{{$global.unit}}</span>
                    </el-input>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        tableData: {
            type: Object,
            default: function () {
                return {};
            },
        },
        addModel:{
            type:Number,
            default:1,
        }
    },
    data() {
        return {
        };
    },
    mounted(){
    },
    computed:{
    },
    methods: {
        checkSpNumber:function(e,spec,val){
            this.$common.checkNumber(e,spec,val);
            this.$emit("checkSpNumber");
        },
    },
};
</script>